import React from 'react';
import {DigitalizedSignatureValues} from 'commons/models';
import {InferPropTypes} from 'commons/types/Types';
import {Form, FormikProps} from 'formik';
import PropTypes from 'prop-types';
import {FieldShape} from 'commons/shapes';
import {Box, Grid} from '@material-ui/core';
import {
    EfeButtonPrimary,
    EfeErrorMsg,
    EfeFormSection,
    EfeSignaturePad,
    EfeSupportMessage,
} from 'components';
import {CallMade} from '@material-ui/icons';

InnerFormConsigneeSign.propTypes = {
    signed: PropTypes.bool.isRequired,
    allowSign: PropTypes.bool.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
};

function InnerFormConsigneeSign(
    props: InferPropTypes<
        typeof InnerFormConsigneeSign.propTypes & FormikProps<DigitalizedSignatureValues>
    >
) {
    const {values, errors, fields, isSubmitting, setFieldValue, signed, allowSign} = props;

    function setSignature(file: string) {
        setFieldValue('signature', file);
    }

    React.useEffect(() => {
        if (values && values.signature) {
            try {
                const file = new File([values.file], 'sign');
                const filePath = {...file};
                filePath.size = file.size;
                filePath.name = file.name;
            } catch (error) {
                console.error(error);
            }
        }
    }, [values]);

    React.useEffect(() => {
        if (signed) {
            setFieldValue('signature', values.signature);
        }
    }, []);

    return (
        <Form noValidate>
            { fields && fields.length > 0 && !allowSign && (
                <Box  m={2}>
                    <EfeErrorMsg message={'Esta secci\u00F3n a\u00FAn no est\u00E1 habilitada para su cuenta.'} />
                    <Grid container direction='row' justifyContent='flex-end'>
                        <Box pt={6} width={160}>
                            <EfeButtonPrimary
                                fullWidth
                                disabled={isSubmitting}
                                type='submit'
                                endIcon={<CallMade />}>
                                {'OK'}
                            </EfeButtonPrimary>
                        </Box>
                    </Grid>
                </Box>
            )}
            {fields && fields.length > 0 && allowSign && (
                <Box m={2}>
                    <EfeSupportMessage />
                    <EfeSignaturePad
                        title={''}
                        description={'Ingrese su firma dentro del recuadro a continuaci\u00F3n'}
                        signature={values.signature}
                        setSignature={setSignature}
                        readonly={signed}
                    />
                    {errors.signature && (
                        <Box mt={5} ml={5}>
                            <EfeErrorMsg message={errors.signature} />
                        </Box>
                    )}
                    <EfeFormSection
                        fields={fields}
                        values={values}
                        errors={errors}
                        setFieldValue={setFieldValue}
                    />
                    <Grid container direction='row' justifyContent='flex-end'>
                        <Box pt={6} width={160}>
                            <EfeButtonPrimary
                                fullWidth
                                disabled={isSubmitting}
                                type='submit'
                                endIcon={<CallMade />}>
                                {'OK'}
                            </EfeButtonPrimary>
                        </Box>
                    </Grid>
                </Box>
            )}
        </Form>
    );
}

export default InnerFormConsigneeSign;
